<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="来源" prop="source_id">
        <el-select v-model="formData.source_id" placeholder="请选择来源" filterable>
          <el-option :key="0" label="请选择来源" :value="formData.source_id"></el-option>
          <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'handpick_author_add',
  props: [
    'visible', 'id', 'sourceList'
  ],
  data () {
    return {
      title: '添加作者',
      formData: {
        title: '',
        source_id: 0
      },
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑作者'
        this.getAuthorInfo(this.id)
      }
    },
    async getAuthorInfo (id) {
      const res = await this.$http.get('/admin/handpick_author/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          source_id: res.data.source_id
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
